import React from "react"

import BulbIcon from "../assets/bulbIcon"
import FlagIcon from "../assets/flagIcon"
import MessageIcon from "../assets/messageIcon"
import StarIcon from "../assets/starIcon"
import TemplatesCoffeeIcon from "../assets/templatesCoffeeIcon"
import GamePadIcon from "../assets/gamePadIcon"

import { ActivityDescription, ActivityEnum } from "../utils/constants"

export const templateDetails: any = [
  {
    template: {
      name: "What inspires us?",
      description:
        "Let’s discuss and recognize where we are drawing our inspiration to give our very best at work.",
      approximateTime: 35,
      logo: <BulbIcon />,
      btnText: "Start social",
      btnTextColor: "yellow-txtBtn",
      arrowColor: "--theme-yellow",
      templateCode: "01b2964c-600b-4dfd-8f42-ccc61d54e49f",
    },
    templateItems: [
      {
        activityName: ActivityEnum.WOULD_YOU_RATHER,
        activityDescription: ActivityDescription.WOULD_YOU_RATHER,
      },
      {
        activityName: ActivityEnum.MINDFUL_TALKS,
        activityDescription: ActivityDescription.MINDFUL_TALKS,
      },
      {
        activityName: ActivityEnum.SHARE_OUT_IN_LOUNGE,
        activityDescription: ActivityDescription.SHARE_OUT_IN_LOUNGE,
      },
    ],
  },

  {
    template: {
      name: "Fun break",
      description: "Filled with our most loved mixers. Guaranteed max fun!",
      approximateTime: 30,
      logo: <GamePadIcon />,
      btnText: "Start social",
      btnTextColor: "scarletRed500-txtBtn",
      arrowColor: "--theme-scarletRed500",
      templateCode: "175fe40a-c194-455e-995a-322d353bc315",
    },
    templateItems: [
      {
        activityName: ActivityEnum.DOODLE_RACE,
        activityDescription: ActivityDescription.DOODLE_RACE,
      },
      {
        activityName: ActivityEnum.TRIVIA,
        activityDescription: ActivityDescription.TRIVIA,
      },
      {
        activityName: ActivityEnum.CHARADES,
        activityDescription: ActivityDescription.CHARADES,
      },
    ],
  },
  {
    template: {
      name: "Welcoming new hires",
      description:
        "Get your new teammate onboarded with our carefully curated set of mixers. The right balance of fun and conversations.",
      approximateTime: 50,
      logo: <FlagIcon />,
      btnText: "Start social",
      btnTextColor: "btn-lightBlueTxt",
      arrowColor: "--theme-lightBlue",
      templateCode: "5431a018-263a-4330-9216-3c0a8b52d9e8",
    },
    templateItems: [
      {
        activityName: ActivityEnum.SPEED_1_1,
        activityDescription: ActivityDescription.SPEED_1_1,
      },
      {
        activityName: ActivityEnum.CHARADES,
        activityDescription: ActivityDescription.CHARADES,
      },
      {
        activityName: ActivityEnum.KNOW_YOUR_TEAM,
        activityDescription: ActivityDescription.KNOW_YOUR_TEAM,
      },
    ],
  },
  {
    template: {
      name: "Appreciation Day",
      description:
        "Discuss ways to create a culture of appreciation and recognition within the team.",
      approximateTime: 35,
      logo: <StarIcon />,
      btnText: "Start social",
      btnTextColor: "yellow-txtBtn",
      arrowColor: "--theme-yellow",
      templateCode: "82769091-39a6-44b8-aa80-93a313d980c1",
    },
    templateItems: [
      {
        activityName: ActivityEnum.WOULD_YOU_RATHER,
        activityDescription: ActivityDescription.WOULD_YOU_RATHER,
      },
      {
        activityName: ActivityEnum.MINDFUL_TALKS_APPRECIATION,
        activityDescription: ActivityDescription.MINDFUL_TALKS,
      },
      {
        activityName: ActivityEnum.SHARE_OUT_IN_LOUNGE,
        activityDescription: ActivityDescription.SHARE_OUT_IN_LOUNGE,
      },
    ],
  },
  {
    template: {
      name: "Chai time",
      description:
        "Connect with your team for a refreshing break - fun games and casual conversations.",
      approximateTime: 45,
      logo: <TemplatesCoffeeIcon />,
      btnText: "Start social",
      btnTextColor: "orange-txtBtn",
      arrowColor: "--theme-orange",
      templateCode: "f2e905cf-c744-4dd5-b57e-6244ebc0c8a8",
    },
    templateItems: [
      {
        activityName: ActivityEnum.ICEBREAKER,
        activityDescription: ActivityDescription.ICEBREAKER,
      },
      {
        activityName: ActivityEnum.TWO_TRUTHS_AND_A_LIE,
        activityDescription: ActivityDescription.TWO_TRUTHS_AND_A_LIE,
      },
      {
        activityName: ActivityEnum.KNOW_YOUR_TEAM,
        activityDescription: ActivityDescription.KNOW_YOUR_TEAM,
      },
      {
        activityName: ActivityEnum.DOODLE_RACE,
        activityDescription: ActivityDescription.DOODLE_RACE,
      },
    ],
  },
  {
    template: {
      name: "Casual Conversations",
      description:
        "A template to engage in conversations with your team. From fast-paced chats on space colonization to uncovering secrets about your teammates.",
      approximateTime: 40,
      logo: <MessageIcon />,
      btnText: "Start social",
      btnTextColor: "green-txtBtn",
      arrowColor: "--theme-green",
      templateCode: "6d786ace-df49-4bf2-9eb2-edf6d746f38e",
    },
    templateItems: [
      {
        activityName: ActivityEnum.SPEED_1_1,
        activityDescription: ActivityDescription.SPEED_1_1,
      },
      {
        activityName: ActivityEnum.WOULD_YOU_RATHER,
        activityDescription: ActivityDescription.WOULD_YOU_RATHER,
      },
    ],
  },
]
